<template>
    <v-container class="my-5">
        <!--    Diálogo  Modal para mostrar mensaje Número de Celular incorrecto    -->
        <v-dialog v-model="dialogCellNumberWrong" max-width="290">
            <v-card>
                <v-card-title class="headline">{{$t('aviso')}}</v-card-title>
                <v-card-text>{{$t('cellphone_wrong')}}</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="dialogCellNumberWrong = false">{{$t('aceptar')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--    Diálogo  Modal para Cambiar Permisos (Usuario -> Administrador)    -->
        <v-dialog
                v-model="dialogMoveUp"
                max-width="600"
        >
            <v-form @submit.prevent="moveUpUserToManager()">
                <v-card class="elevation-5">
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>
                            {{$t('move_up_user_to_manager')}}
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn
                                class="align-self-end"
                                color="red"
                                icon
                                @click="dialogMoveUp = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text>
                        <v-layout row wrap>
                            <v-autocomplete
                                    autofocus
                                    v-model="emailGuest"
                                    :items="items"
                                    prepend-icon="mdi-email"
                                    :loading="isLoading"
                                    :search-input.sync="search2"
                                    :item-text="example"
                                    item-value="id"
                                    :placeholder="$t('placeholder_invitados2')"
                                    :label="$t('usuarios')"
                                    :error-messages="errores.idUser"
                                    :no-data-text="$t('no_resultados')"
                                    clearable
                                    autocomplete="off"
                            >
                                <template v-slot:selection="data">
                                    <v-chip
                                            v-bind="data.attrs"
                                            :input-value="data.selected"
                                            @click="data.select"
                                    >
                                        <v-avatar left>
                                            <v-img :src="data.item.avatar"></v-img>
                                        </v-avatar>
                                        {{ data.item.first_name }} {{data.item.last_name}}
                                    </v-chip>
                                </template>
                                <template v-slot:item="data">
                                    <template v-if="typeof data.item !== 'object'">
                                        <v-list-item-content v-text="data.item"></v-list-item-content>
                                    </template>
                                    <template v-else>
                                        <v-list-item-avatar>
                                            <img :src="data.item.avatar">
                                        </v-list-item-avatar>
                                        <v-list-item-content>
                                            <v-list-item-title>{{ data.item.first_name }} {{data.item.last_name}}</v-list-item-title>
                                            <v-list-item-sub-title v-html="data.item.group"></v-list-item-sub-title>
                                        </v-list-item-content>
                                    </template>
                                </template>
                            </v-autocomplete>
                            <v-autocomplete
                                    v-model="id_empresa"
                                    prepend-icon="mdi-home-city"
                                    item-text="name"
                                    item-value="id"
                                    :label="$t('Fraccionamientos')"
                                    :filter="customFilter"
                                    :error-messages="errores.idHousingUnit"
                                    :items="housing_units"
                                    no-data-text="Ningún Resultado"
                                    clearable
                                    autocomplete="off"
                            >
                                <template v-slot:selection="data">
                                    <v-chip
                                            v-bind="data.attrs"
                                            :input-value="data.selected"
                                            @click="data.select"
                                    >
                                        <v-avatar left>
                                            <v-img :src="data.item.logo"></v-img>
                                        </v-avatar>
                                        {{ data.item.name }}
                                    </v-chip>
                                </template>
                                <template v-slot:item="data">
                                    <template v-if="typeof data.item !== 'object'">
                                        <v-list-item-content v-text="data.item"></v-list-item-content>
                                    </template>
                                    <template v-else>
                                        <v-list-item-avatar>
                                            <img :src="data.item.logo">
                                        </v-list-item-avatar>
                                        <v-list-item-content>
                                            <v-list-item-title v-html="data.item.name"></v-list-item-title>
                                        </v-list-item-content>
                                    </template>
                                </template>
                            </v-autocomplete>
                        </v-layout>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn
                                color="primary"
                                @click="dialogMoveUp = false"
                        >
                            {{$t('cerrar')}}
                        </v-btn>
                        <v-spacer/>
                        <v-btn
                                color="primary"
                                :loading="loading"
                                type="submit"
                        >
                            {{$t('modificar')}}
                            <v-icon dark right>mdi-swap-horizontal</v-icon>
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
        <!--   Diálogo para Mostrar un mensaje al Eliminar Administrador     -->
        <v-dialog
                v-model="deleteDialog"
                max-width="450"
        >
            <v-card>
                <v-card-title class="headline">
                    {{$t('msg_delete_manager')}}
                </v-card-title>

                <v-card-text>
                    {{$t('msg_accion_deshacer')}}
                </v-card-text>
                <v-card-actions>
                    <v-btn
                            color="primary"
                            @click="deleteDialog = false"
                    >
                        No
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="primary"
                            @click="deleteManager()"
                    >
                        {{$t('Si')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--     Diálogo Modal Persistente para Recortar la Imagen Identificacón Oficial Frontal      -->
        <v-dialog v-model="dialogImageFront" persistent scrollable max-width="800px">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>
                        {{$t('recortar_imagen')}}
                    </v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <clipper-fixed
                            :rotate="degrees"
                            :ratio="ratio"
                            ref="clipperImageFront"
                            :src="imageFrontURL">
                    </clipper-fixed>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-col>
                        <v-row xs12 class="justify-center">
                            <v-radio-group
                                    v-model="ratio"
                                    name="ratio"
                                    row
                                    label="Ratio"
                                    :mandatory="false"
                            >
                                <v-radio label="1:1" value="1"></v-radio>
                                <v-radio label="3:2" value="1.5"></v-radio>
                                <v-radio label="4:3" value="1.3333333333333333"></v-radio>
                                <v-radio label="16:9" value="1.7777777777777777"></v-radio>
                            </v-radio-group>
                        </v-row>
                        <v-row xs12 class="justify-center mr-6">
                            <v-slider
                                    v-model="degrees"
                                    :label="$t('grados')"
                                    step="1"
                                    max="180"
                                    min="-180"
                                    thumb-label="always"
                            ></v-slider>
                        </v-row>
                        <v-row class="justify-center">
                            <v-btn
                                    color="primary"
                                    @click="getCutingFront()"
                            >{{$t('recortar')}}</v-btn>
                        </v-row>
                    </v-col>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--     Diálogo Modal Persistente para Recortar la Imagen Identificacón Oficial Atrás      -->
        <v-dialog v-model="dialogImageBack" persistent scrollable max-width="800px">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>
                        {{$t('recortar_imagen')}}
                    </v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <clipper-fixed
                            :rotate="degrees"
                            :ratio="ratio"
                            ref="clipperImageBack"
                            :src="imageBackURL">
                    </clipper-fixed>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-col>
                        <v-row xs12 class="justify-center">
                            <v-radio-group
                                    v-model="ratio"
                                    name="ratio"
                                    row
                                    label="Ratio"
                                    :mandatory="false"
                            >
                                <v-radio label="1:1" value="1"></v-radio>
                                <v-radio label="3:2" value="1.5"></v-radio>
                                <v-radio label="4:3" value="1.3333333333333333"></v-radio>
                                <v-radio label="16:9" value="1.7777777777777777"></v-radio>
                            </v-radio-group>
                        </v-row>
                        <v-row xs12 class="justify-center mr-6">
                            <v-slider
                                    v-model="degrees"
                                    :label="$t('grados')"
                                    step="1"
                                    max="180"
                                    min="-180"
                                    thumb-label="always"
                            ></v-slider>
                        </v-row>
                        <v-row xs12 class="justify-center">
                            <v-btn
                                    color="primary"
                                    @click="getCutingBack()"
                            >{{$t('recortar')}}</v-btn>
                        </v-row>
                    </v-col>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--     Diálogo Modal Persistente para Recortar la Foto de perfil      -->
        <v-dialog v-model="dialogImageProfile" persistent scrollable max-width="800px">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>
                        {{$t('recortar_imagen')}}
                    </v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <clipper-fixed
                            class="basic lg"
                            :src="imageProfileURL"
                            ref="clipperImageProfile"
                            :rotate="degrees"
                            :round="true"
                            preview="preview">
                    </clipper-fixed>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-col>
                        <v-row xs12 class="justify-center mr-6">
                            <v-slider
                                    v-model="degrees"
                                    :label="$t('grados')"
                                    step="1"
                                    max="180"
                                    min="-180"
                                    thumb-label="always"
                            ></v-slider>
                        </v-row>
                        <v-row xs12 class="justify-center">
                            <v-btn
                                    color="primary"
                                    @click="getCutingProfile()"
                            >{{$t('recortar')}}</v-btn>
                        </v-row>
                    </v-col>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <h2 class="subheading grey--text">{{ $t('department_manager') }}</h2>
        <v-layout align-center justify-center fill-height>
            <v-dialog v-model="dialog" persistent scrollable max-width="900px">
                <template v-slot:activator="{ on }">
                    <v-layout row wrap class="justify-center">
                        <v-btn
                                color="primary"
                                dark
                                v-on="on"
                                @click="update = false,
                                cleanFields()"> + {{ $t('add_department_manager') }}
                        </v-btn>
                        <!-- <v-btn
                                arrow_upward
                                color="primary"
                                @click="openMoveUpDialog()"
                        >
                            <v-icon dark left>mdi-swap-horizontal</v-icon>
                            {{$t('cambiar_permisos')}}
                        </v-btn> -->
                    </v-layout>
                </template>
                <v-form
                        @submit.prevent="update
                                        ? updateManager(id_update)
                                        : createManager()">
                    <v-card class="elevation-5">
                        <v-toolbar dark color="primary">
                            <v-toolbar-title>
                                <v-icon left>mdi-account-plus</v-icon>
                                {{ update ? $t('edit_department_manager') || 'Editar Administrador' : $t('add_department_manager') || 'Nuevo Administrador' }}
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn
                                    icon
                                    @click="clear(), dialog = false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-toolbar>

                        <v-tabs v-model="activeTab" background-color="grey lighten-4" color="primary" grow>
                            <v-tab>
                                <v-icon left>mdi-account</v-icon>
                                {{ $t('datos_personales') || 'Datos Personales' }}
                            </v-tab>
                            <v-tab>
                                <v-icon left>mdi-file-document</v-icon>
                                {{ $t('documentos') || 'Documentos' }}
                            </v-tab>
                            <v-tab>
                                <v-icon left>mdi-shield-account</v-icon>
                                {{ $t('permisos') || 'Permisos' }}
                            </v-tab>
                        </v-tabs>

                        <v-tabs-items v-model="activeTab" class="modal-scrollable-content">
                            <!-- Tab 1: Datos Personales -->
                            <v-tab-item>
                                <v-card-text class="pt-6">
                                    <v-row>
                                        <v-col cols="12" md="6">
                                            <v-text-field
                                                    v-model="first_name"
                                                    prepend-icon="mdi-account"
                                                    :label="$t('Nombre')"
                                                    :error-messages="errores_seg.first_name"
                                                    outlined
                                                    dense
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <v-text-field
                                                    v-model="last_name"
                                                    prepend-icon="mdi-account-outline"
                                                    :label="$t('Apellido')"
                                                    :error-messages="errores_seg.last_name"
                                                    outlined
                                                    dense
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <v-text-field
                                                    v-model="email"
                                                    prepend-icon="mdi-email"
                                                    label="E-Mail"
                                                    :error-messages="errores_seg.email"
                                                    autocomplete="username"
                                                    outlined
                                                    dense
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <vue-tel-input
                                                    class="vue-tel-input-custom"
                                                    v-model="celular"
                                                    @onInput="onInput"
                                            ></vue-tel-input>
                                            <v-alert outlined v-if="errores_seg.cellNumber" type="error" dense class="mt-2">{{errores_seg.cellNumber}}</v-alert>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <v-menu
                                                    v-model="birthdateMenu"
                                                    :close-on-content-click="false"
                                                    transition="scale-transition"
                                                    offset-y
                                                    min-width="auto"
                                            >
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field
                                                            v-model="birthdate"
                                                            :label="$t('fecha_nacimiento')"
                                                            prepend-icon="mdi-calendar"
                                                            readonly
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            outlined
                                                            dense
                                                            :error-messages="errores_seg.birthdate"
                                                    ></v-text-field>
                                                </template>
                                                <v-date-picker
                                                        v-model="birthdate"
                                                        @input="birthdateMenu = false"
                                                        :max="new Date().toISOString().substr(0, 10)"
                                                ></v-date-picker>
                                            </v-menu>
                                        </v-col>
                                    </v-row>

                                    <v-divider class="my-4"></v-divider>

                                    <v-subheader class="pl-0">
                                        <v-icon left color="primary">mdi-lock</v-icon>
                                        {{ $t('credenciales') || 'Credenciales de Acceso' }}
                                    </v-subheader>

                                    <ValidationObserver>
                                        <v-row>
                                            <v-col cols="12" v-if="update">
                                                <v-switch
                                                        v-model="change_password"
                                                        :label="$t('cambiar_password') || 'Cambiar Contraseña'"
                                                        color="primary"
                                                        hide-details
                                                ></v-switch>
                                            </v-col>
                                            <v-col cols="12" md="6">
                                                <ValidationProvider name="password" vid="password" :rules="change_password ? 'required' : ''" v-slot="{ errors }">
                                                    <v-text-field
                                                            autocomplete="new-password"
                                                            v-model="password"
                                                            :disabled="update && !change_password"
                                                            prepend-icon="mdi-lock"
                                                            :label="$t('password')"
                                                            :type="show ? 'text' : 'password'"
                                                            :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                                                            @click:append="show = !show"
                                                            :error-messages="errors[0] || (change_password ? errores_seg.password : '')"
                                                            outlined
                                                            dense
                                                    ></v-text-field>
                                                </ValidationProvider>
                                            </v-col>
                                            <v-col cols="12" md="6">
                                                <ValidationProvider name="confirm" :rules="change_password ? 'required|password:@password' : ''" v-slot="{ errors }">
                                                    <v-text-field
                                                            autocomplete="new-password"
                                                            v-model="confirmation"
                                                            :disabled="update && !change_password"
                                                            prepend-icon="mdi-lock-check"
                                                            :label="$t('password_confirm')"
                                                            :type="show ? 'text' : 'password'"
                                                            :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                                                            @click:append="show = !show"
                                                            :error-messages="errors[0]"
                                                            outlined
                                                            dense
                                                    ></v-text-field>
                                                </ValidationProvider>
                                            </v-col>
                                        </v-row>
                                    </ValidationObserver>

                                    <v-alert :value="alerta" type="warning" outlined transition="scale-transition" class="mt-3">
                                        Fallo con el Servidor
                                    </v-alert>
                                </v-card-text>
                            </v-tab-item>

                            <!-- Tab 2: Documentos -->
                            <v-tab-item>
                                <v-card-text class="pt-6">
                                    <v-row justify="center">
                                        <!-- Foto de Perfil -->
                                        <v-col cols="12" sm="4" class="text-center">
                                            <v-card outlined class="pa-4">
                                                <v-subheader class="justify-center">
                                                    <v-icon left color="primary">mdi-account-circle</v-icon>
                                                    {{$t('foto_perfil')}}
                                                </v-subheader>
                                                <div class="avatar-wrapper mx-auto my-3">
                                                    <v-avatar size="120" color="grey lighten-3">
                                                        <v-img v-if="resultProfileURL" :src="resultProfileURL"></v-img>
                                                        <v-icon v-else size="60" color="grey">mdi-account</v-icon>
                                                    </v-avatar>
                                                </div>
                                                <clipper-upload
                                                        class="upload-btn primary"
                                                        @input="dialog = false, dialogImageProfile = true, degrees = 0, ratio = '1'"
                                                        accept="image/*"
                                                        v-model="imageProfileURL"
                                                >
                                                    <v-icon left small dark>mdi-upload</v-icon>
                                                    {{$t('subir_imagen')}}
                                                </clipper-upload>
                                                <v-alert v-if="errores_seg.avatar" type="error" outlined dense class="mt-3">
                                                    {{errores_seg.avatar}}
                                                </v-alert>
                                            </v-card>
                                        </v-col>

                                        <!-- INE Frente -->
                                        <v-col cols="12" sm="4" class="text-center">
                                            <v-card outlined class="pa-4">
                                                <v-subheader class="justify-center">
                                                    <v-icon left color="primary">mdi-card-account-details</v-icon>
                                                    {{$t('foto_ine')}} [{{$t('frente')}}]
                                                </v-subheader>
                                                <div class="doc-preview my-3">
                                                    <v-img
                                                            v-if="resultFrontURL"
                                                            :src="resultFrontURL"
                                                            height="100"
                                                            contain
                                                            class="grey lighten-3 rounded"
                                                    ></v-img>
                                                    <v-sheet v-else height="100" class="d-flex align-center justify-center grey lighten-3 rounded">
                                                        <v-icon size="40" color="grey">mdi-card-account-details-outline</v-icon>
                                                    </v-sheet>
                                                </div>
                                                <clipper-upload
                                                        class="upload-btn primary"
                                                        @input="dialog = false, dialogImageFront = true, degrees = 0, ratio = '1'"
                                                        accept="image/*"
                                                        v-model="imageFrontURL"
                                                >
                                                    <v-icon left small dark>mdi-upload</v-icon>
                                                    {{$t('subir_imagen')}}
                                                </clipper-upload>
                                                <v-alert v-if="errores_seg.idFront" type="error" outlined dense class="mt-3">
                                                    {{errores_seg.idFront}}
                                                </v-alert>
                                            </v-card>
                                        </v-col>

                                        <!-- INE Atrás -->
                                        <v-col cols="12" sm="4" class="text-center">
                                            <v-card outlined class="pa-4">
                                                <v-subheader class="justify-center">
                                                    <v-icon left color="primary">mdi-card-account-details</v-icon>
                                                    {{$t('foto_ine')}} [{{$t('atras')}}]
                                                </v-subheader>
                                                <div class="doc-preview my-3">
                                                    <v-img
                                                            v-if="resultBackURL"
                                                            :src="resultBackURL"
                                                            height="100"
                                                            contain
                                                            class="grey lighten-3 rounded"
                                                    ></v-img>
                                                    <v-sheet v-else height="100" class="d-flex align-center justify-center grey lighten-3 rounded">
                                                        <v-icon size="40" color="grey">mdi-card-account-details-outline</v-icon>
                                                    </v-sheet>
                                                </div>
                                                <clipper-upload
                                                        class="upload-btn primary"
                                                        @input="dialog = false, dialogImageBack = true, degrees = 0, ratio = '1'"
                                                        accept="image/*"
                                                        v-model="imageBackURL"
                                                >
                                                    <v-icon left small dark>mdi-upload</v-icon>
                                                    {{$t('subir_imagen')}}
                                                </clipper-upload>
                                                <v-alert v-if="errores_seg.idBack" type="error" outlined dense class="mt-3">
                                                    {{errores_seg.idBack}}
                                                </v-alert>
                                            </v-card>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-tab-item>

                            <!-- Tab 3: Permisos -->
                            <v-tab-item>
                                <v-card-text class="pt-6">
                                    <v-row justify="center">
                                        <v-col cols="12" md="8">
                                            <v-alert type="info" text dense class="mb-4">
                                                Seleccione los permisos que tendrá este administrador en el sistema.
                                            </v-alert>
                                            <v-list dense class="permissions-list">
                                                <v-list-item>
                                                    <v-list-item-content>
                                                        <v-list-item-title>{{$t('rol_department_manager') || 'Gestor de Departamentos'}}</v-list-item-title>
                                                        <v-list-item-subtitle>Administrar departamentos y áreas</v-list-item-subtitle>
                                                    </v-list-item-content>
                                                    <v-list-item-action>
                                                        <v-switch v-model="roles.department_manager" color="primary" hide-details></v-switch>
                                                    </v-list-item-action>
                                                </v-list-item>
                                                <v-list-item>
                                                    <v-list-item-content>
                                                        <v-list-item-title>{{$t('rol_starter') || 'Starter'}}</v-list-item-title>
                                                        <v-list-item-subtitle>Control de salidas de golf</v-list-item-subtitle>
                                                    </v-list-item-content>
                                                    <v-list-item-action>
                                                        <v-switch v-model="roles.starter" color="primary" hide-details></v-switch>
                                                    </v-list-item-action>
                                                </v-list-item>
                                                <v-list-item>
                                                    <v-list-item-content>
                                                        <v-list-item-title>{{$t('rol_associates') || 'Socios'}}</v-list-item-title>
                                                        <v-list-item-subtitle>Gestionar socios del club</v-list-item-subtitle>
                                                    </v-list-item-content>
                                                    <v-list-item-action>
                                                        <v-switch v-model="roles.associates" color="primary" hide-details></v-switch>
                                                    </v-list-item-action>
                                                </v-list-item>
                                                <v-list-item>
                                                    <v-list-item-content>
                                                        <v-list-item-title>{{$t('rol_account_statements') || 'Estados de Cuenta'}}</v-list-item-title>
                                                        <v-list-item-subtitle>Ver y gestionar estados de cuenta</v-list-item-subtitle>
                                                    </v-list-item-content>
                                                    <v-list-item-action>
                                                        <v-switch v-model="roles.account_statements" color="primary" hide-details></v-switch>
                                                    </v-list-item-action>
                                                </v-list-item>
                                                <v-list-item>
                                                    <v-list-item-content>
                                                        <v-list-item-title>{{$t('rol_sports') || 'Deportes'}}</v-list-item-title>
                                                        <v-list-item-subtitle>Administrar actividades deportivas</v-list-item-subtitle>
                                                    </v-list-item-content>
                                                    <v-list-item-action>
                                                        <v-switch v-model="roles.sports" color="primary" hide-details></v-switch>
                                                    </v-list-item-action>
                                                </v-list-item>
                                                <v-list-item>
                                                    <v-list-item-content>
                                                        <v-list-item-title>{{$t('rol_employees') || 'Empleados'}}</v-list-item-title>
                                                        <v-list-item-subtitle>Gestionar personal del club</v-list-item-subtitle>
                                                    </v-list-item-content>
                                                    <v-list-item-action>
                                                        <v-switch v-model="roles.employees" color="primary" hide-details></v-switch>
                                                    </v-list-item-action>
                                                </v-list-item>
                                                <v-list-item>
                                                    <v-list-item-content>
                                                        <v-list-item-title>{{$t('rol_golf_admin') || 'Administrador de Golf'}}</v-list-item-title>
                                                        <v-list-item-subtitle>Control total del módulo de golf</v-list-item-subtitle>
                                                    </v-list-item-content>
                                                    <v-list-item-action>
                                                        <v-switch v-model="roles.golf_admin" color="primary" hide-details></v-switch>
                                                    </v-list-item-action>
                                                </v-list-item>
                                                <v-list-item>
                                                    <v-list-item-content>
                                                        <v-list-item-title>{{$t('rol_golf_public_relations') || 'Relaciones Públicas de Golf'}}</v-list-item-title>
                                                        <v-list-item-subtitle>Gestionar comunicaciones y eventos de golf</v-list-item-subtitle>
                                                    </v-list-item-content>
                                                    <v-list-item-action>
                                                        <v-switch v-model="roles.golf_public_relations" color="primary" hide-details></v-switch>
                                                    </v-list-item-action>
                                                </v-list-item>
                                            </v-list>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-tab-item>
                        </v-tabs-items>

                        <v-divider></v-divider>
                        <v-card-actions class="pa-4">
                            <v-btn
                                    text
                                    @click="clear(), dialog = false"
                            >
                                <v-icon left>mdi-close</v-icon>
                                {{$t('cerrar')}}
                            </v-btn>
                            <v-spacer/>
                            <v-btn
                                    color="primary"
                                    :loading="loading"
                                    type="submit"
                            >
                                <v-icon left>{{ update ? 'mdi-content-save' : 'mdi-plus' }}</v-icon>
                                {{ update ? $t('modificar') : $t('agregar') }}
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-dialog>
        </v-layout>
        <v-layout class="my-4" align-center justify-center fill-height>
            <v-flex >
                <v-card-title>
                    {{$t('department_manager')}}
                    <v-spacer></v-spacer>
                    <v-text-field
                            v-model="search"
                            append-icon="mdi-account-search"
                            :label="$t('Buscar')"
                            single-line
                            hide-details
                    ></v-text-field>
                </v-card-title>
                <v-data-table
                        :headers="headers"
                        :loading="loading_data_administradores"
                        :items="administradores"
                        :search="search"
                        :footer-props="{
                            itemsPerPageOptions: [
                                {text: '5', value: 5},
                                {text: '10', value: 10},
                                {text: '25', value: 25},
                                {text: this.$t('todos'), value: -1}
                            ],
                            itemsPerPageText: $t('filas_por_pagina')
                        }"
                        :no-data-text="$t('no_records_yet')"
                        class="elevation-1"
                >
                    <template v-slot:item="{ item }">
                        <tr>
                            <td>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon
                                                v-bind="attrs"
                                                v-on="on"
                                                medium
                                                color="gray"
                                                class="mr-2"
                                                @click="fillFields(item), update = true, dialog = true, id_update = item.id"
                                        >
                                            mdi-account-edit
                                        </v-icon>
                                    </template>
                                    <span>{{$t('change')}}</span>
                                </v-tooltip>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon
                                                v-bind="attrs"
                                                v-on="on"
                                                medium
                                                color="red"
                                                class="mr-2"
                                                @click="deleteDialog = true, idManagerDelete = item.id"
                                        >
                                            mdi-delete
                                        </v-icon>
                                    </template>
                                    <span>{{$t('delete')}}</span>
                                </v-tooltip>
                            </td>
                            <td>{{ item.idUser.first_name }}</td>
                            <td>{{ item.idUser.last_name }}</td>
                            <td>{{ item.idUser.cellNumber }}</td>
                            <td>{{ item.idUser.email }}</td>
                        </tr>
                    </template>
                    <template v-slot:no-results>
                        <v-alert type="warning">
                            {{$t('ningun_resultado_1')}} "{{ search }}" {{$t('ningun_resultado_2')}}
                        </v-alert>
                    </template>
                </v-data-table>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import axios from 'axios'
import store from '@/store'
import VuejsClipper from 'vuejs-clipper'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import { mapGetters, mapState } from 'vuex'
import Vue from 'vue'
import { required } from 'vee-validate/dist/rules'

const BASE_URL = 'https://clubtest.intrare.app'

extend('password', {
  params: ['target'],
  validate (value, { target }) {
    return value === target
  },
  message: 'Password confirmation does not match'
})

extend('required', {
  ...required,
  message: 'This field is required'
})

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)
Vue.use(VuejsClipper, {
  components: {
    clipperBasic: 'clipper-basic',
    clipperFixed: 'clipper-fixed',
    clipperUpload: 'clipper-upload'
  }
})

// const dictionary = {
//   en: {
//     messages: {
//       confirmed: () => 'The passwords didn\'t match',
//       required: () => 'This field is required'
//     }
//   },
//   es: {
//     messages: {
//       confirmed: () => 'Las contraseñas no coinciden',
//       required: () => 'Este campo es requerido'
//     }
//   }
// }

// Validator.localize(dictionary)
// const validator = new Validator({ confirmation: 'confirmed' })
// Falta investigar como cambiar el idioma de los mensajes
// con vue-validate
// validator.localize(this.$store.state.language);
// validator.localize('es')

export default {
  name: 'department_manager',
  created: function () {
    this.getManagers()
    this.getHousingUnits()
  },
  data: () => ({
    show: false,
    alerta: false,
    dialog: false,
    update: false,
    activeTab: 0,
    id_update: 0,
    first_name: '',
    last_name: '',
    celular: '',
    email: '',
    email_aux: '',
    celular_aux: '',
    birthdate: null,
    birthdateMenu: false,
    password: '',
    errores: [],
    errores_seg: [],
    headers: [],
    administradores: [],
    change_password: '',
    loading_data_administradores: false,
    loading: false,
    confirmation: '',
    search: '',
    // Imágenes
    dialogImageFront: false,
    dialogImageBack: false,
    dialogImageProfile: false,
    imageFrontURL: '',
    imageBackURL: '',
    imageProfileURL: '',
    resultFrontURL: '',
    resultBackURL: '',
    resultProfileURL: '',
    resultAuxFrontURL: '',
    resultAuxBackURL: '',
    resultAuxProfileURL: '',
    // Delete Manager
    deleteDialog: false,
    idManagerDelete: 0,
    // Move Up
    dialogMoveUp: false,
    emailGuest: '',
    isLoading: false,
    search2: null,
    entries: [],
    band_cellphone: false,
    dialogCellNumberWrong: false,
    degrees: 0,
    ratio: '1',
    // Housing Units
    housing_units: [],
    id_empresa: null,
    // Roles/Permisos para Move Up
    moveUpRoles: {
      department_manager: false,
      starter: false,
      associates: false,
      account_statements: false,
      sports: false,
      employees: false,
      golf_admin: false,
      golf_public_relations: false
    },
    // Roles/Permisos
    roles: {
      department_manager: false,
      starter: false,
      associates: false,
      account_statements: false,
      sports: false,
      employees: false,
      golf_admin: false,
      golf_public_relations: false
    }
  }),
  beforeUpdate () {
    this.headers = [
      {
        text: this.$t('acciones'),
        align: 'center',
        value: 'action',
        sortable: false
      },
      {
        text: this.$t('Nombre'),
        align: 'left',
        sortable: true,
        value: 'idUser.first_name'
      },
      {
        text: this.$t('Apellido'),
        align: 'left',
        sortable: true,
        value: 'idUser.last_name'
      },
      {
        text: this.$t('celular'),
        align: 'left',
        sortable: true,
        value: 'idUser.cellNumber'
      },
      {
        text: 'E-Mail',
        align: 'left',
        sortable: true,
        value: 'idUser.email'
      }
    ]
  },
  computed: {
    ...mapGetters(['getProfile']),
    ...mapState(['language']),
    fields () {
      if (!this.emailGuest) return []

      return Object.keys(this.emailGuest).map(key => {
        return {
          key,
          value: this.emailGuest[key] || 'n/a'
        }
      })
    },
    items () {
      return this.entries.map(entry => {
        const email = entry.first_name.length > this.descriptionLimit
          ? entry.first_name.slice(0, this.descriptionLimit) + '...'
          : entry.first_name

        return Object.assign({}, entry, { email })
      })
    }
  },
  watch: {
    'roles.starter' (val) {
      if (val && this.roles.golf_admin) {
        this.roles.golf_admin = false
      }
    },
    'roles.golf_admin' (val) {
      if (val && this.roles.starter) {
        this.roles.starter = false
      }
    },
    'roles.golf_public_relations' (val) {
      if (val && this.roles.starter && this.roles.golf_admin) {
        this.roles.starter = false
        this.roles.golf_admin = false
      }
    },
    isUpdating (val) {
      if (val) {
        setTimeout(() => (this.isUpdating = false), 3000)
      }
    },
    search2 (val) {
      if (val.length > 2) {
        this.isLoading = true
        // Lazily load input items
        const config = {
          method: 'get',
          url: BASE_URL + '/guests/filter?search=' + val,
          headers: {
            'Content-Type': 'application/json',
            'authorization': 'Token ' + store.getters.getToken
          }
        }
        axios(config)
          .then(response => {
            console.log(response.data)
            if (this.entries.length > 0) {
              for (var i = 0; i < response.data.length; i++) {
                this.entries.push(response.data[i])
              }
            } else {
              this.entries = response.data
            }
          })
          .catch(error => {
            console.log(error)
          })
          .finally(() => (this.isLoading = false))
      }
    }
  },
  methods: {
    openMoveUpDialog () {
      this.dialogMoveUp = true
      this.emailGuest = ''
      this.entries = []
      this.errores = []
      this.id_empresa = null
      // Limpiar roles
      this.moveUpRoles = {
        department_manager: false,
        starter: false,
        associates: false,
        account_statements: false,
        sports: false,
        employees: false,
        golf_admin: false,
        golf_public_relations: false
      }
    },
    getManagers: function () {
      this.loading_data_administradores = true
      const config = {
        method: 'get',
        url: BASE_URL + '/administrator_manager/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          this.administradores = response.data
          this.loading_data_administradores = false
        })
        .catch(error => {
          this.loading_data_administradores = false
          console.log(error)
        })
    },
    getHousingUnits: function () {
      const config = {
        method: 'get',
        url: BASE_URL + '/housing_unit/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          this.housing_units = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    customFilter (item, queryText, itemText) {
      const textOne = item.name ? item.name.toLowerCase() : ''
      const searchText = queryText.toLowerCase()
      return textOne.indexOf(searchText) > -1
    },
    createManager: function () {
      if (this.band_cellphone === true) {
        this.loading = true
        this.errores = []
        this.errores_seg = []
        var bodyFormData = new FormData()
        var fileImageFront = null
        var fileImageBack = null
        var fileImageProfile = null

        bodyFormData.set('idUser.first_name', this.first_name)
        bodyFormData.set('idUser.last_name', this.last_name)
        bodyFormData.set('idUser.cellNumber', this.celular)
        bodyFormData.set('idUser.email', this.email.toLowerCase())
        bodyFormData.set('idUser.password', this.password)
        bodyFormData.set('idUser.birthdate', this.birthdate)
        bodyFormData.set('idHousingUnit', this.getProfile.idHousingUnit)
        // Roles/Permisos
        bodyFormData.set('department_manager', this.roles.department_manager)
        bodyFormData.set('starter', this.roles.starter)
        bodyFormData.set('associates', this.roles.associates)
        bodyFormData.set('account_statements', this.roles.account_statements)
        bodyFormData.set('sports', this.roles.sports)
        bodyFormData.set('employees', this.roles.employees)
        bodyFormData.set('golf_admin', this.roles.golf_admin)
        bodyFormData.set('golf_public_relations', this.roles.golf_public_relations)
        if (this.resultFrontURL !== '' && this.resultFrontURL.length > 6) {
          fileImageFront = this.dataURLtoFile(this.resultFrontURL, 'ine_front.jpeg')
        }
        bodyFormData.append('idUser.idFront', fileImageFront)
        if (this.resultBackURL !== '' && this.resultBackURL.length > 6) {
          fileImageBack = this.dataURLtoFile(this.resultBackURL, 'ine_back.jpeg')
        }
        bodyFormData.append('idUser.idBack', fileImageBack)
        if (this.resultProfileURL !== '' && this.resultProfileURL.length > 6) {
          fileImageProfile = this.dataURLtoFile(this.resultProfileURL, 'avatar.jpeg')
        }
        bodyFormData.append('idUser.avatar', fileImageProfile)
        const config = {
          method: 'post',
          url: BASE_URL + '/administrator_manager/',
          headers: {
            'Content-Type': 'application/json',
            'Accept-Language': this.language,
            'authorization': 'Token ' + store.getters.getToken
          },
          data: bodyFormData
        }
        axios(config)
          .then(ok => {
            this.loading = false
            this.getManagers()
            this.$store.commit('snackbar_activate_true')
            this.$store.commit('snackbar_change_message', this.$t('msg_department_manage_added'))
            this.dialog = false
            setTimeout(this.clear, 3000)
          })
          .catch(error => {
            this.loading = false
            if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
              if (error.response.data) {
                this.errores = error.response.data
              }
              if (error.response.data.idUser) {
                this.errores_seg = error.response.data.idUser
              }
            }
          })
      } else {
        this.dialogCellNumberWrong = true
      }
    },
    updateManager: function (id) {
      if (this.band_cellphone === true) {
        this.loading = true
        this.errores = []
        this.errores_seg = []
        var bodyFormData = new FormData()
        var fileImageFront = null
        var fileImageBack = null
        var fileImageProfile = null

        if (this.email_aux !== this.email) {
          // idUser['email'] = this.email.toLowerCase()
          bodyFormData.set('idUser.email', this.email.toLowerCase())
        }
        if (this.celular_aux !== this.celular) {
          bodyFormData.set('idUser.cellNumber', this.celular)
          // idUser['cellNumber'] = this.celular
        }
        if (this.change_password === true) {
          bodyFormData.set('idUser.password', this.password)
          // idUser['password'] = this.password
        }
        if (this.resultFrontURL !== this.resultAuxFrontURL) {
          const newID = this.$uuid.v4()
          if (this.resultFrontURL !== '' && this.resultFrontURL.length > 6) {
            fileImageFront = this.dataURLtoFile(this.resultFrontURL, 'ine_front' + newID + '.jpeg')
          }
          bodyFormData.append('idUser.idFront', fileImageFront)
        }
        if (this.resultBackURL !== this.resultAuxBackURL) {
          const newID = this.$uuid.v4()
          if (this.resultBackURL !== '' && this.resultBackURL.length > 6) {
            fileImageBack = this.dataURLtoFile(this.resultBackURL, 'ine_back' + newID + '.jpeg')
          }
          bodyFormData.append('idUser.idBack', fileImageBack)
        }
        if (this.resultProfileURL !== this.resultAuxProfileURL) {
          const newID = this.$uuid.v4()
          if (this.resultProfileURL !== '' && this.resultProfileURL.length > 6) {
            fileImageProfile = this.dataURLtoFile(this.resultProfileURL, 'avatar' + newID + '.jpeg')
          }
          bodyFormData.append('idUser.avatar', fileImageProfile)
        }
        bodyFormData.set('idUser.first_name', this.first_name)
        bodyFormData.set('idUser.last_name', this.last_name)
        bodyFormData.set('idUser.birthdate', this.birthdate)
        bodyFormData.set('idHousingUnit', this.getProfile.idHousingUnit)
        // Roles/Permisos
        bodyFormData.set('department_manager', this.roles.department_manager)
        bodyFormData.set('starter', this.roles.starter)
        bodyFormData.set('associates', this.roles.associates)
        bodyFormData.set('account_statements', this.roles.account_statements)
        bodyFormData.set('sports', this.roles.sports)
        bodyFormData.set('employees', this.roles.employees)
        bodyFormData.set('golf_admin', this.roles.golf_admin)
        bodyFormData.set('golf_public_relations', this.roles.golf_public_relations)
        const config = {
          method: 'patch',
          url: BASE_URL + '/administrator_manager/' + id,
          headers: {
            'Content-Type': 'application/json',
            'Accept-Language': this.language,
            'authorization': 'Token ' + store.getters.getToken
          },
          data: bodyFormData
        }
        axios(config)
          .then(ok => {
            this.loading = false
            this.getManagers()
            this.$store.commit('snackbar_activate_true')
            this.$store.commit('snackbar_change_message', this.$t('msg_department_manage_updated'))
            this.dialog = false
            setTimeout(this.clear, 3000)
          })
          .catch(error => {
            this.loading = false
            console.log(error.response.data)
            if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
              if (error.response.data) {
                this.errores = error.response.data
              }
              if (error.response.data.idUser) {
                this.errores_seg = error.response.data.idUser
              }
            }
          })
      } else {
        this.dialogCellNumberWrong = true
      }
    },
    deleteManager () {
      const config = {
        method: 'delete',
        url: BASE_URL + '/administrator_manager/' + this.idManagerDelete,
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config).then(ok => {
        console.log('Manager con ID = ', this.idManagerDelete + ' eliminado Correctamente.')
        this.$store.commit('snackbar_activate_true')
        this.$store.commit('snackbar_change_color', 'warning')
        this.$store.commit('snackbar_change_message', this.$t('mensaje_administrador_eliminada'))
        this.getManagers()
        setTimeout(this.clear, 3000)
        this.deleteDialog = false
      })
        .catch(error => {
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            this.errores = error.response.data
          }
        })
    },
    clear: function () {
      this.alerta = false
      this.errores = []
      this.errores_seg = []
      // this.$validator.reset()
      this.$store.commit('snackbar_change_color', 'success')
      this.$store.commit('snackbar_activate_false')
    },
    moveUpUserToManager () {
      this.loading = true
      this.errores = []
      const config = {
        method: 'PUT',
        url: BASE_URL + '/administrator/make_from_guest/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        },
        data: {
          idUser: this.emailGuest,
          idHousingUnit: this.id_empresa
        }
      }
      axios(config)
        .then(ok => {
          this.loading = false
          this.getManagers()
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('msg_cambio_permisos'))
          this.dialogMoveUp = false
          setTimeout(this.clear, 3000)
        })
        .catch(error => {
          this.loading = false
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            this.errores = error.response.data
          }
        })
    },
    fillFields (item) {
      this.first_name = item.idUser.first_name
      this.last_name = item.idUser.last_name
      this.celular = item.idUser.cellNumber
      this.email = item.idUser.email
      this.email_aux = item.idUser.email
      this.celular_aux = item.idUser.cellNumber
      this.birthdate = item.idUser.birthdate || null
      this.password = ''
      this.confirmation = ''
      this.change_password = false
      this.resultFrontURL = item.idUser.idFront
      this.resultBackURL = item.idUser.idBack
      this.resultProfileURL = item.idUser.avatar
      this.resultAuxFrontURL = item.idUser.idFront
      this.resultAuxBackURL = item.idUser.idBack
      this.resultAuxProfileURL = item.idUser.avatar
      this.band_cellphone = true
      // Cargar roles existentes
      this.roles.department_manager = item.department_manager || false
      this.roles.starter = item.starter || false
      this.roles.associates = item.associates || false
      this.roles.account_statements = item.account_statements || false
      this.roles.sports = item.sports || false
      this.roles.employees = item.employees || false
      this.roles.golf_admin = item.golf_admin || false
      this.roles.golf_public_relations = item.golf_public_relations || false
    },
    cleanFields () {
      this.first_name = ''
      this.last_name = ''
      this.celular = ''
      this.email = ''
      this.email_aux = ''
      this.celular_aux = ''
      this.birthdate = null
      this.password = ''
      this.confirmation = ''
      this.change_password = true
      this.resultFrontURL = ''
      this.resultBackURL = ''
      this.resultProfileURL = ''
      this.activeTab = 0
      // Limpiar roles
      this.roles.department_manager = false
      this.roles.starter = false
      this.roles.associates = false
      this.roles.account_statements = false
      this.roles.sports = false
      this.roles.employees = false
      this.roles.golf_admin = false
      this.roles.golf_public_relations = false
    },
    getCutingFront () {
      console.log('Datos de la imagen = ', this.imageFrontURL.size)
      const canvas = this.$refs.clipperImageFront.clip() // call component's clip method
      this.resultFrontURL = canvas.toDataURL('image/jpeg', 0.2) // canvas->image
      console.log(this.resultFrontURL)
      this.dialogImageFront = false
      this.dialog = true
    },
    getCutingBack () {
      const canvas = this.$refs.clipperImageBack.clip() // call component's clip method
      this.resultBackURL = canvas.toDataURL('image/jpeg', 0.2) // canvas->image
      console.log(this.resultBackURL)
      this.dialogImageBack = false
      this.dialog = true
    },
    getCutingProfile () {
      const canvas = this.$refs.clipperImageProfile.clip() // call component's clip method
      this.resultProfileURL = canvas.toDataURL('image/jpeg', 0.2) // canvas->image
      console.log(this.resultProfileURL)
      this.dialogImageProfile = false
      this.dialog = true
    },
    dataURLtoFile (dataurl, filename) {
      var arr = dataurl.split(',')
      var mime = arr[0].match(/:(.*?);/)[1]
      var bstr = atob(arr[1])
      var n = bstr.length
      var u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, { type: mime })
    },
    example: item => item.first_name + ' ' + item.last_name,
    onInput ({ number, isValid, country }) {
      console.log(number.e164)
      console.log(isValid)
      console.log(country)
      this.celular = number.e164
      this.band_cellphone = isValid
    }
  }
}
</script>

<style scoped>
    .edge {
        border-radius: 8px;
        border-color: #2a2738 #2a2738 #2a2738 #2a2738;
        border-width: 3px 3px 3px 3px;
        text-align: center;
        border-style: solid solid solid solid;
    }
    .wrapper{
        width:200px;
        height:200px;
        position: relative;
        margin: 25px auto;
        overflow: hidden;
        border-radius:50%;
        border: 5px solid #2a2738;
    }
    .wrapper img{
        position: relative;
        width:100%;
        height:auto;
    }
    .splash-info {
        background: #ffffff;
        position: relative;
        z-index: 2;
        margin-bottom: 30px;
        text-align: center;
        font-size:15px;
        font-weight:bold;
    }
    .permissions-list {
        background: transparent !important;
    }
    .permissions-list .v-list-item {
        border-bottom: 1px solid rgba(0,0,0,0.08);
        padding: 12px 0;
    }
    .permissions-list .v-list-item:last-child {
        border-bottom: none;
    }
    .permissions-list .v-list-item-subtitle {
        font-size: 0.75rem !important;
        color: rgba(0,0,0,0.5) !important;
    }
    .vue-tel-input-custom {
        border: 1px solid rgba(0,0,0,0.38);
        border-radius: 4px;
        padding: 8px 12px;
        height: 40px;
    }
    .vue-tel-input-custom:focus-within {
        border-color: var(--v-primary-base);
        border-width: 2px;
    }
    .avatar-wrapper {
        display: flex;
        justify-content: center;
    }
    .doc-preview {
        min-height: 100px;
    }
    .modal-scrollable-content {
        max-height: 60vh;
        overflow-y: auto;
    }
    .upload-btn {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: 0 16px;
        height: 28px;
        font-size: 0.875rem;
        font-weight: 500;
        letter-spacing: 0.0892857143em;
        text-transform: uppercase;
        border-radius: 4px;
        color: white;
        cursor: pointer;
        transition: background-color 0.2s;
    }
    .upload-btn.primary {
        background-color: var(--v-primary-base, #1976D2);
    }
    .upload-btn.primary:hover {
        background-color: var(--v-primary-darken1, #1565C0);
    }
</style>
